/**
 * Browser copy of functions-common/weeklyTime/week.js.
 * The node test checks the two stay in sync.
 */
export function londonIsoWeekKey(date = new Date()) {
	const parts = new Intl.DateTimeFormat("en-US", {
		timeZone: "Europe/London",
		year: "numeric",
		month: "2-digit",
		day: "2-digit",
	}).formatToParts(date);

	const year = Number(parts.find((part) => part.type === "year").value);
	const month = Number(parts.find((part) => part.type === "month").value);
	const day = Number(parts.find((part) => part.type === "day").value);
	const utc = new Date(Date.UTC(year, month - 1, day));
	const dayNum = utc.getUTCDay() || 7;
	utc.setUTCDate(utc.getUTCDate() + 4 - dayNum);
	const isoYear = utc.getUTCFullYear();
	const yearStart = new Date(Date.UTC(isoYear, 0, 1));
	const week = Math.ceil(((utc - yearStart) / 86400000 + 1) / 7);
	return `${isoYear}-W${String(week).padStart(2, "0")}`;
}
